module.exports = __webpack_public_path__ + "static/media/GR.be0d63c3.svg";